import React, { useEffect, useState } from "react";
import { classNames } from "../../helpers/classNames";
import Button from "../../components/form/Button";
import Image from "../../components/elements/Image";
import GoogleLogo from "../../assets/image/google.svg";
import FacebookLogo from "../../assets/image/facebook.svg";
import AppleLogo from "../../assets/image/apple.svg";
import AuthenticationForm from "../../components/sections/front/Authentication/AuthenticationForm";
import { socialLogin, socialLoginApple } from "../../services/socialLogin";
import { toast } from "react-toastify";
import FullScreenLoader from "../../components/common/FullScreenLoader";
import { LoginSocialApple } from "reactjs-social-login";
import { useBanner } from "../../providers/BannerProviders";
import { useLocation } from "react-router-dom";

const Login = () => {
  const [currentView, setCurrentView] = useState("signin");
  const [isLoder, setIsloder] = useState(false);
  const [socialData, setSocialData] = useState([]);
  const [isVideoFile, setIsVideoFile] = useState(false);
  const location = useLocation();
  const { data } = useBanner();
  const [loginBanner, setLoginBanner] = useState(null);
  useEffect(() => {
    if (currentView === "signin" && data?.data?.length > 0) {
      const foundBanner = data?.data?.find(
        (item) => item?.bannerType === "login"
      );
      setLoginBanner(foundBanner);
    } else if (data?.data?.length > 0) {
      const foundBanner = data?.data?.find(
        (item) => item?.bannerType === "sign-up"
      );
      setLoginBanner(foundBanner);
    }
  }, [currentView, data?.data]);

  useEffect(() => {
    if (loginBanner?.image?.url) {
      const ext = loginBanner?.image?.url?.split(".").pop()?.toLowerCase();
      setIsVideoFile(["mp4", "webm"].includes(ext));
    }
  }, [loginBanner?.image?.url]);

  console.log(location);

  useEffect(() => {
    if (typeof window !== "undefined") {
      import("reactjs-social-login").then((module) => {
        const { LoginSocialFacebook, LoginSocialGoogle } = module;

        const socialArray = [
          {
            _id: 1,
            name: "Facebook",
            image: FacebookLogo,
            component: ({ children }) => (
              <LoginSocialFacebook
                appId="727000659669596"
                fieldsProfile="id,first_name,last_name,middle_name,name,picture,email,gender"
                scope="public_profile,email"
                onLoginStart={() => {
                  setIsloder(true); // Show loader right when login starts
                }}
                onResolve={async ({ provider, data }) => {
                  socialLogin({
                    type: "fb",
                    role: "user",
                    loginData: {
                      sub: data?.userID,
                      name: data?.name,
                      given_name: data?.first_name,
                      picture: data?.picture?.data?.url,
                      email_verified: true,
                      email: data?.email,
                    },
                  }).then((res) => {
                    if (res?.status === 200) {
                      toast.success(res?.message);
                      localStorage.setItem("auth_token", res?.accessToken);
                      localStorage.setItem("refreshToken", res?.refreshToken);
                      window.location.href =
                        window.location.origin + "/user/dashboard";
                    } else {
                      toast?.error(res?.message);
                    }
                    setIsloder(false); // Hide loader after response
                  });
                }}
                onReject={(err) => {
                  console.log("Facebook Login Error", err);
                  setIsloder(false); // Hide loader on error
                }}
              >
                {children}
              </LoginSocialFacebook>
            ),
          },
          {
            _id: 2,
            name: "Google",
            image: GoogleLogo,
            component: ({ children }) => (
              <LoginSocialGoogle
                client_id="602148628506-qe0428mdseibb4pp6a473u36kr3rr7qv.apps.googleusercontent.com"
                scope="openid profile email"
                onLoginStart={() => {
                  setIsloder(true); // Show loader as soon as login starts
                }}
                onResolve={({ provider, data }) => {
                  socialLogin({
                    type: "google",
                    role: "user",
                    loginData: {
                      sub: data.sub,
                      name: data.name,
                      given_name: data.given_name,
                      picture: data?.picture,
                      email_verified: data.email_verified,
                      email: data.email,
                    },
                  }).then((res) => {
                    if (res?.status === 200) {
                      toast.success(res?.message);
                      localStorage.setItem("auth_token", res?.accessToken);
                      localStorage.setItem("refreshToken", res?.refreshToken);
                      window.location.href =
                        window.location.origin + "/user/dashboard";
                    } else {
                      toast?.error(res?.data?.message);
                    }
                    setIsloder(false);
                  });
                }}
                onReject={(err) => {
                  console.log("Google Login Error", err);
                  setIsloder(false); // Hide loader on error too
                }}
              >
                {children}
              </LoginSocialGoogle>
            ),
          },
          {
            _id: 21,
            name: "Apple",
            image: AppleLogo,
            component: ({ children }) => (
              <LoginSocialApple
                client_id="com.vpeters.web" // Example: com.yourcompany.web
                redirect_uri="https://vpeters.org/" // Must match what’s set in Apple Developer settings
                scope="name email"
                onLoginStart={() => setIsloder(true)}
                onResolve={({ provider, data }) => {
                  socialLoginApple({
                    type: "apple",
                    role: "user",

                    loginData: {
                      id_token: data.authorization.id_token,
                      code: data.authorization.code,
                    },
                  }).then((res) => {
                    if (res?.status === 200) {
                      toast.success(res?.message);
                      localStorage.setItem("auth_token", res?.accessToken);
                      localStorage.setItem("refreshToken", res?.refreshToken);
                      window.location.href =
                        window.location.origin + "/user/dashboard";
                    } else {
                      toast?.error(res?.data?.message);
                    }
                    setIsloder(false);
                  });
                }}
                onReject={(err) => {
                  console.log("Apple Login Error", err);
                  setIsloder(false);
                }}
              >
                {children}
              </LoginSocialApple>
            ),
          },
        ];
        setSocialData(socialArray);
      });
    }
  }, []);

  return (
    <section className="relative flex items-center w-full min-h-screen py-16 sm:py-24 bg-white z-0">
      <div className="fixed top-0 left-0 w-full h-full z-[-1] flex">
        {isVideoFile ? (
          <video
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-full object-cover object-center"
            src={loginBanner?.image?.url}
          />
        ) : (
          <Image
            src={loginBanner?.image?.url}
            alt=""
            effect={"blur"}
            classes={"object-cover"}
          />
        )}
      </div>
      <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
        <div className="flex justify-center">
          <div className="relative py-8 md:py-12 px-8 md:px-12 bg-gradient-to-b from-slate-100 to-primary/70 w-full max-w-lg rounded-r-xl overflow-hidden border-l-2 border-primary xls:backdrop-blur-md shadow-xl">
            <div className="absolute right-6 top-6 text-white">
              <a
                href="/admin/signin"
                target="_blank"
                rel="noopener noreferrer"
                className="!text-sm !font-semibold inline-block rounded-md !text-white !p-2 !h-auto bg-gray-500 border border-primary hover:bg-primary transition-all duration-300 hover:border-white shadow-xl"
              >
                Admin
              </a>
            </div>

            <div className="space-y-8">
              <div className="text-3xl text-primary font-semibold text-center mt-5">
                {currentView === "signin"
                  ? "Sign In"
                  : currentView === "signup"
                  ? "Sign Up"
                  : ""}
              </div>
              <AuthenticationForm
                currentView={currentView}
                setCurrentView={setCurrentView}
                donorData={location?.state}
              />
              <div className="overflow-hidden flex items-center justify-center relative">
                <span
                  className={classNames(
                    "relative inline-flex items-center justify-center bg-transparent text-white font-CanelaDeck capitalize",
                    "before:content-[''] before:absolute before:top-1/2 before:left-[calc(100%+12px)] before:w-[400px] before:border-t before:border-white/60 before:mt-px",
                    "after:content-[''] after:absolute after:top-1/2 after:right-[calc(100%+12px)] after:w-[400px] after:border-t after:border-white/60 after:mt-px"
                  )}
                >
                  or{" "}
                  {currentView === "signin"
                    ? "sign in"
                    : currentView === "signup"
                    ? "sign up"
                    : ""}{" "}
                  with
                </span>
              </div>
              {socialData?.length > 0 && (
                <div className="flex items-center justify-center gap-4">
                  {socialData.map((item, index) => {
                    const ButtonContent = (
                      <Button
                        key={item._id}
                        onClick={item.onClick} // optional, will be ignored for Facebook
                        buttonClasses="!bg-white/75 !rounded-xl !p-2 !h-auto !border-none hover:!bg-white/100"
                        buttonLabel={
                          <div className="w-8 aspect-square overflow-hidden">
                            <Image
                              src={item.image}
                              alt={item.name}
                              effect={"blur"}
                              classes={"object-contain"}
                            />
                          </div>
                        }
                      />
                    );

                    // If a special component like LoginSocialFacebook exists, wrap the button
                    return item.component ? (
                      <item.component key={item._id}>
                        {ButtonContent}
                      </item.component>
                    ) : (
                      ButtonContent
                    );
                  })}
                </div>
              )}

              <div className="text-center flex items-center justify-center text-sm gap-x-2 text-white">
                <span>
                  {currentView === "signin"
                    ? "Don’t have an account?"
                    : currentView === "signup"
                    ? "Already have an account?"
                    : ""}
                </span>
                <Button
                  buttonLabel={
                    currentView === "signin"
                      ? "Sign Up"
                      : currentView === "signup"
                      ? "Sign In"
                      : ""
                  }
                  buttonLabelClasses={"!text-sm !font-semibold"}
                  buttonClasses={
                    "!h-auto !py-1 !px-3 !bg-white !text-primary !rounded-2xl"
                  }
                  buttonFunction={
                    currentView === "signin"
                      ? () => setCurrentView("signup")
                      : currentView === "signup"
                      ? () => setCurrentView("signin")
                      : () => {}
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoder && <FullScreenLoader />}
    </section>
  );
};

export default Login;
